<template>
  <NuxtLayout name="seminar-lp-for1-column">
    <template #title>
      <span style="font-size:1rem;">【AIと法務について興味がある方／法律を学んだ方／法務部員を目指している方】</span>
      <h1>{{ pageTitle }}</h1>
      <v-chip class="attorneys-seminar ma-2" label>
        ウェビナー
      </v-chip>
    </template>
    <template #terminated>
      <div v-show="isExpiredApply" style="background-color:#aeaeae;">このセミナーは終了しました</div>
    </template>
    <template #main-visual>
      <v-img width="100%" heghit="100%" :aspect-ratio="960/540" preload contain class="mv mx-auto" :src="`/img/${route.path.replace(/^\//, '')}/mv.webp`" type="image/webp" alt="セミナー">
        <source width="960" heghit="540" :srcset="`/img/${route.path.replace(/^\//, '')}/mv.png`" type="image/png" />
      </v-img>
    </template>
    <template #detail>
      <p class="heading-4 text-center ma-2" style="font-size:larger;font-weight:bold;">
        AIの仕組みを学べば、<br class="d-sm-none" />AIと上手く付き合える
      </p>
      <p>法務部員は、人材不足とされる一方で、AIによって仕事が奪われるとも言われています。<br />
        AIはすでに便利な道具ですが、今後さらに高性能・多機能になっていきます。<br />
        <br />
        しかし、AIは決して万能ではありません。情報漏えいなどの危険も伴います。<br />
        AIとうまく付き合っていくためには、AIの仕組みを理解することが必要です。<br />
        <br />
        仕組みがわかれば、利用規約のどこをチェックすれば良いか、<br />
        AIにどのような指示を出せばよいかがわかります。<br />
        AIを使いこなせれば、法務としてのキャリアが広がります。</p>
      <dl>
        <dt>
          <h3>主催</h3>
        </dt>
        <dd>
          Attorney's MAGAZINE 編集部<br />
          株式会社C&Rリーガル･エージェンシー社
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>日時</h3>
        </dt>
        <dd>
          {{ getDateTimeString(eventStartDateTime, eventEndDateTime) }}
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>申込期日</h3>
        </dt>
        <dd>
          {{ getDateString(eventExpiresApplyDateTime, {
            isDisplayDayShort: true,
            isDisplayedTime: true,
          }) }}
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>参加対象者</h3>
        </dt>
        <dd>
          <ul>
            <li>企業法務部の仕事に興味がある方</li>
            <li>
              法務部員としてスキルアップしたい方<br />
              ┗ AIがどのように仕事に役立つのか知りたい
            </li>
            <li>
              法務部員としてAIとの付き合い方に悩んでいる方<br />
              ┗ どのAIを使って良いのかわからない
            </li>
            <li>
              法務部員としてのキャリア形成に興味がある方<br />
              ┗ AIが法務部員の業務にどのような影響を及ぼすのか知りたい
            </li>
            <li>
              せっかく学んだ法律知識を活かしたい方<br />
              ┗ AIがどのような法律問題を引き起こすのか知りたい
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>会場</h3>
        </dt>
        <dd>
          オンライン
          <ul class="notice">
            <li>当日の参加URLはオンラインセミナー当日までにメールにてお知らせいたします。</li>
            <li>
              ご視聴の環境により、セミナーのご視聴ができない可能性がございます。<br />
              その場合、申込完了後のメールに記載しているメールアドレスまでご連絡ください。
            </li>
          </ul>
        </dd>
      </dl>
      <dl>
        <dt>
          <h3>注意事項</h3>
        </dt>
        <dd>
          <ul class="notice">
            <li>同業他社からのお申込はお断りさせていただきます。</li>
            <li>申込者多数の場合は抽選となる可能性がございますので、ご了承ください。</li>
            <li>都合によりプログラムの内容・登壇者が変更となる場合がございます。</li>
          </ul>
        </dd>
      </dl>
      <h3>登壇者</h3>
      <AppCardSpeakerCard v-for="speaker in speakers" :speaker="speaker" />
    </template>
    <template #form>
      <AppForm202509SeminarStepForm class="mx-auto" :isExpiredApply="isExpiredApply" />
    </template>
    <template #floating-navigation>
      <AppFloatingButtonsGoToApplication v-if="isExpiredApply === false" targetQuerySelector="#application" :targetElementTopOffset="-64" />
    </template>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { Speaker } from '@/types/person';
import { getDateTimeString, getDateString } from '@/utils/Date';

const route = useRoute();
const runtimeConfig = useRuntimeConfig();

const pageTitle : string = '仕組みから学ぶ 法務部員なら知っておきたいAIとの付き合い方';
const pageDescription : string = '法務部員なら知っておきたいAIの仕組みと付き合い方。利用規約の重要なポイントを見抜き適切なAIサービスを選定するためのAIリテラシーを養います。';

const eventStartDateTimeString: string = '2025-09-11T19:30:00.000+09:00';
const eventEndDateTimeString: string = '2025-09-11T21:00:00.000+09:00';
const expiredTImeForApplySeminar: string = '2025-09-11T18:50:00.000+09:00';

const isExpiredApply: boolean = (new Date()).getTime() > new Date(expiredTImeForApplySeminar).getTime();

const eventStartDateTime: Date = new Date(eventStartDateTimeString);
const eventEndDateTime: Date = new Date(eventEndDateTimeString);
const eventExpiresApplyDateTime: Date = new Date(eventStartDateTime.getFullYear(), eventStartDateTime.getMonth(), eventStartDateTime.getDate(), eventStartDateTime.getHours(), eventStartDateTime.getMinutes() - 10, eventStartDateTime.getSeconds());
const speakers: Speaker[] = [
  {
    name: '柿沼 彰 氏',
    job_role: '柿沼彰法律事務所 弁護士',
    image: {
      alt: '講師 柿沼 彰 氏',
      proper: {
        src: `/img/${route.path.replace(/^\//, '')}/kakinuma.jpg`,
        type: 'image/jpg',
      },
      webp: {
        src: `/img/${route.path.replace(/^\//, '')}/kakinuma.webp`,
        type: 'image/webp',
      },
    },
    biography: '2010年弁護士登録、上場IT企業経営企画室を経て2015年独立開業。「機械学習プログラミング」による市場分析で経済学修士（東京大学）を取得。企業勤務・独立後を通じて、ネットワークカメラを用いた顧客動線の分析と陳列の最適化、画像認識技術を用いた板金修理箇所の調査と中古自動車の価格査定、AIボットを用いた面接トレーニング等の「AIビジネスの立ち上げ」に関与。現在は複数企業を巡回して「社内AI研修」や「社内AI利用ガイドライン」の策定にも従事する「フリーランスの法務部員」として活動。東京弁護士会所属。',
  }
];

definePageMeta({
  isr: {
    revalidate: 3600,
  }
});

useHead({
  link: [
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/png",
      href: `/img/${route.path.replace(/^\//, '')}/mv.png`,
      as: 'image',
    },
    {
      rel: 'preload',
      fetchpriority: "high",
      type: "image/webp",
      href: `/img/${route.path.replace(/^\//, '')}/mv.webp`,
      as: 'image',
    },
    {
      rel: 'canonical',
      href: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Event",
        "name": `2025年9月セミナー｜【AIと法務について興味がある方／法律を学んだ方／法務部員を目指している方】${pageTitle}`,
        "description": pageDescription,
        "startDate": formatDateWithTimezone(eventStartDateTime),
        "endDate": formatDateWithTimezone(eventEndDateTime),
        "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "VirtualLocation",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
        },
        "image": [
          `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
        ],
        "offers": {
          "@type": "Offer",
          "url": `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
          "price": 0,
          "priceCurrency": "JPY",
          "availability": "https://schema.org/InStock",
        },
        "performer": speakers.map(speaker => ({
          "@type": "Person",
          "name": speaker.name,
        })),
        "organizer": {
          "@type": "Organization",
          "name": "C&Rリーガル･エージェンシー社",
          "url": "https://legal-agent.jp/",
        },
      }),
    },
  ],
});
useSeoMeta({
  title: `【AIと法務について興味がある方／法律を学んだ方／法務部員を目指している方】${pageTitle}`,
  description: pageDescription,
  keywords: '企業法務, 法務部 キャリア, 法務職 転職, 法学部 就職先, 法律系 就職, インハウスロイヤー, 法務部 就職活動, 法律職 セミナー, 法務部のリアル, 法律専門職 キャリアセミナー, オンライン法務セミナー, AIリテラシー, 法務部員必須, ビジネス理解, AIガイドライン, キャリア形成',
  ogUrl: `${runtimeConfig.public.appUrlOrigin}/${route.path.replace(/^\//, '')}`,
  ogTitle: `【AIと法務について興味がある方／法律を学んだ方／法務部員を目指している方】${pageTitle}`,
  ogDescription: pageDescription,
  ogImageUrl: `${runtimeConfig.public.appUrlOrigin}/img/${route.path.replace(/^\//, '')}/mv.png`,
});
</script>
